<div class="sm:tw-w-[440px]">
  <!-- title -->
  <ng-container *ngIf="isShowDialogTitle">
    <app-modal-title [isShowClose]="true" (isCloseModal)="onClose(false)">
    </app-modal-title>
  </ng-container>

  <div mat-dialog-content class="dialog-content">
    <app-fields-management-form
      [isModalMode]="true"
      (isCloseModal)="onClose($event)"
    >
    </app-fields-management-form>
  </div>
</div>
